import { createReducer, createSelector } from '@reduxjs/toolkit'
import { get, has, keyBy } from 'lodash'

import { HIGHLY, MOST, OPEN, SELECTIVE, SOMEWHAT, VERY, getSelectivityLabelFromHS } from 'common/use-selectivity-label'

import jsActions from './actions'
import tsActions from './actions-typed'
import types from './types'

export const actions = {
  ...jsActions,
  ...tsActions,
}

export const selectUser = (store) => get(store, 'user.record', {})
export const selectHighSchool = (store) => get(selectUser(store), 'HighSchool')
export const selectCurrentSeniorYear = (store) => get(selectUser(store), 'HighSchool.CurrentSeniorYear')
export const selectPreferredGPA = (store) => get(selectUser(store), 'HighSchool.PreferredGPA', 'Unweighted')
export const selectHighSchoolId = (store) => get(selectUser(store), 'HighSchoolId', null)
export const selectSupportsSavedViews = (store) => get(selectUser(store), 'HighSchool.SupportsSavedViews', false)
export const selectSupportPrinciplesYou = (store) =>
  get(selectUser(store), 'HighSchool.PrinciplesYouStudentsCanConnect', false)
export const selectSISConfig = (store) => get(selectUser(store), 'HighSchool.SISConfig', false)
export const selectStaff = selectUser

export const selectPermissions = (state) => get(state, 'user.record.Permissions', [])
const selectKeyedPermissions = createSelector(selectPermissions, (perms) => keyBy(perms))
export const hasPermission = (state, permission) => {
  if (!permission) {
    throw `invalid permission "${permission}"`
  }
  return has(selectKeyedPermissions(state), permission)
}
export const isShadow = (state) => get(state, 'user.record.IsShadow', false)

export default createReducer(
  {},
  {
    [types.FETCH_USER_SUCCESS]: (state, action) => ({ record: action.payload }),
    [types.SET_USER_PREFERENCE]: (state, action) => {
      state.record.Preferences = state.record.Preferences || {}
      state.record.Preferences[action.payload.name] = action.payload.value
    },
  },
)

export const selectAcceptanceLikelihoodLabels = (store) => {
  const hs = selectHighSchool(store)
  return {
    FarReach: get(hs, 'AcceptanceLikelihoodFarReachLabel', 'Far Reach'),
    Reach: get(hs, 'AcceptanceLikelihoodReachLabel', 'Reach'),
    Level: get(hs, 'AcceptanceLikelihoodLevelLabel', 'Level'),
    Likely: get(hs, 'AcceptanceLikelihoodLikelyLabel', 'Likely'),
    VeryLikely: get(hs, 'AcceptanceLikelihoodVeryLikelyLabel', 'Very Likely'),
  }
}

export const selectSelectivityLabels = (store) => {
  const hs = selectHighSchool(store)
  return {
    [MOST]: getSelectivityLabelFromHS(hs, MOST),
    [HIGHLY]: getSelectivityLabelFromHS(hs, HIGHLY),
    [VERY]: getSelectivityLabelFromHS(hs, VERY),
    [SELECTIVE]: getSelectivityLabelFromHS(hs, SELECTIVE),
    [SOMEWHAT]: getSelectivityLabelFromHS(hs, SOMEWHAT),
    [OPEN]: getSelectivityLabelFromHS(hs, OPEN),
  }
}
export const selectSelectivityLabelsByValue = (store) => {
  const labels = selectSelectivityLabels(store)
  return {
    6: labels[MOST],
    5: labels[HIGHLY],
    4: labels[VERY],
    3: labels[SELECTIVE],
    2: labels[SOMEWHAT],
    1: labels[OPEN],
  }
}
export const selectPreferences = (store) => {
  const user = selectUser(store)
  return get(user, 'Preferences', {})
}
export const selectPreference = (store, pref) => {
  const preferences = selectPreferences(store)
  return get(preferences, pref, false)
}
